module.exports = __webpack_public_path__ + "static/media/teams.396b82e4.mp3";